<template>
   <div class="row">
    <div class="top-bar vd-top-bar">
      <div class="top-bar-left"><p>Dashboard</p></div>
      <burger/>
      <div class="top-bar-right">
        <span>
          <p class="text-gray-styled-important" v-if="cameras.length">
            Showing {{ cameras.length }}/{{ total }} cams
          </p>
        </span>

        <div class="vd-pagination">
          <a href="#" :key="index" :class="{'pagination-link': true, 'active-pagination': page != item}" @click.prevent="goto(item)" v-for="(item, index) in pages">{{ item }}</a>
        </div>
        <div class="vd-grid-options">
          <a href="#" class="two-grid vd-grid-link" @click.prevent="decrement()">
            <i class="fas fa-th-large"></i>
          </a>
          &nbsp; &nbsp;
          <a href="#" class="three-grid vd-grid-link" @click.prevent="increment()">
            <i class="fas fa-th"></i>
          </a>
        </div>
      </div>
    </div>

    <div class="container-main right-container-video">
      <!-- ATTENDANCE TRACKING SMALL -->
      <div class="vd-attendance-tracking">
        <div class="row vd-logs-top">
          <p>Logs</p>
          <div class="dropdown" style="float:left;">
            <button class="dropbtn video-dropdown">
              <p>Filter &nbsp;<i class="fas fa-caret-down"></i></p>
            </button>
            <div class="dropdown-content dropdown-content-dashboard vd-dropdown">
              <a href="#" @click="updateCategory()">All</a>
              <a href="#" @click="updateCategory(1)">Unidentified</a>
              <a href="#" @click="updateCategory(2)">Identified</a>
            </div>
          </div>
        </div>
        <div class="row attendance-tracking-small" id="items-container">
          <a class="vd-item-link" v-for="item in items" :key="item.id" :href="`/events?user_id=${item.user.id}`" v-if="(status == null || item.category == status)">
            <div class="row item vd-item">
              <div class="col-md-3 avatar avatar-small">
                <p>CAM {{ item.camera_id }}</p>
                <img :src="item.image_crop_path" class="identified-border" alt="" v-if="item.category == 2">
                <img :src="item.image_crop_path" class="unidentified-border" alt="" v-else>
              </div>
              <div class="col-md-9 vd-person-data" v-if="item.category == 2">
                <p class='identified-status vd-identified' v-if="item.user">
                  {{ item.user.first_name }} {{ item.user.last_name }}
                </p>
                <br>
                <p class="vd-start_time">{{ moment(item.time_start).format('MMM DD h:mm A') }} </p>
                <p class="vd-start_time">- {{ moment(item.time_end).format('MMM DD h:mm A') }}</p>
                <p class="vd-id-label">Person ID</p>
                <p class="vd-id">&nbsp; {{ item.user.id }}</p>
              </div>

              <div class="col-md-8 vd-person-data" v-else>
                <p class='unidentified-status'>
                  Unidentified
                </p>
                <p class="vd-start_time">{{ moment(item.time_start).format('MMM DD h:mm A') }}</p>
                <p class="vd-start_time">{{ ' - ' + moment(item.time_end).format('MMM DD h:mm A') }}</p>
                <p class="vd-id-label">Person ID</p>
                <p class="vd-id">&nbsp; {{ item.user.id }}</p>
              </div>
            </div>
          </a>
        </div>
      </div>
    </div>
    <div class="row right-container-video">
      <!-- IMAGES CONTAINER -->
      <div class="video-dashboard-container">
        <div class="dashboard-grid-container">
          <div :class="`vd-footage-conatiner-box vid-footage-box-${grid}`" v-for="(camera, index) in cameras" :key="index">
            <div class="footage-labels">
              <p>HD</p>
              <p>{{ camera.name }}</p>
              <p><img src=".././assets/images/Thermo .svg" alt=""></p>
            </div>
            <div class="row row-footage-2" style="margin-right: 0; margin-left: 0; cursor: pointer;" @click="redirect(`video/dashboard/cam/${camera.id}`)">
              <div class="col vd-footage-box vd-footage-box-1">
                <img style="-webkit-user-select: none;" :src="`${camera.path}`">
              </div>
              <!-- remove thermal cameras for now
              <div class="col vd-footage-box vd-footage-box-2">
                <img style="-webkit-user-select: none;" :src="`${camera.path}/thermal`">
              </div>
               -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  // import SimpleBar from 'simplebar';
  import Burger from '@/components/Burger';

  const url = '/video/dashboard/cams';

  export default {
    name: 'VideoDashboard',
    components: {
      Burger
    },
    data() {
      return {
        pagination: {
          limits: [1, 2, 4, 9, 16, 25],
          current: this.getCurrent(),
          start: 0
        },
        cameras: [],
        items: {},
        schedule: null,
        status: null,
        page: parseInt(this.$route.query.page ? this.$route.query.page : 1),
        pages: 1,
        total: 1,
        loading: false,
        end: false
      };
    },
    computed: {
      url() {
        return this.axios.defaults.baseURL;
      },
      grid() {
        if (!this.pagination.current) {
          return 1;
        }

        if ([1, 2].includes(this.pagination.current)) {
          return 2;
        }

        return this.pagination.current;
      }
    },
    mounted() {
      this.initPage();
      // this.$nextTick(function () {
      //     setTimeout(() => {
          // let el = new SimpleBar(document.getElementById('items-container'));
      //     }, 5000);
      //   })
    },
    beforeDestroy() {
      clearInterval(this.schedule);
    },
    methods: {
      getCurrent() {
        let current = this.$route.query.current;

        if (current > -1 && current < 6) {
          return parseInt(current);
        }

        return 2;
      },
      increment() {
        if (this.pagination.current < this.pagination.limits.length - 1) {
          this.pagination.current++;
          this.$router.push(`${url}?current=${this.pagination.current}`);
          this.pagination.start = 0;
          this.getCameras();
        }
      },
      decrement() {
        if (this.pagination.current > 0) {
          this.pagination.current--;
          this.$router.push(`${url}?current=${this.pagination.current}`);
          this.pagination.start = 0;
          this.getCameras();
        }
      },
      initPage() {
        this.getCameras();
        // let el = new SimpleBar(document.getElementById('items-container'));

        this.schedule = setInterval(() => {
          this.getItems();
          // el = new SimpleBar(document.getElementById('items-container'));
        }, 5000);
      },
      updateCategory(status = null) {
        this.status = status;
        this.getItems();
      },
      getParams() {
        let data = { compact: '1' };

        data['camera_ids'] = this.cameras.map(camera => camera.id);

        if (this.status != null) {
          data['category'] = this.status;
        }

        return data;
      },
      getItems() {
        this.axios.get(`/events`, { params: this.getParams() })
          .then((response) => {
            this.items = response.data.events;
            // setTimeout(() => {
            //   new SimpleBar(document.getElementById('items-container'));
            // }, 2000);
          });
      },
      goto(page) {
        this.page = page;
        this.$router.push(`${url}?page=${this.page}&current=${this.pagination.current}`);
        this.load();
      },
      load() {
        this.pagination.start = (this.page - 1) * this.pagination.limits[this.pagination.current];
        this.getCameras();
      },
      getCameras() {
        if (this.loading || this.end) {
          return;
        }

        let data = {
          // camera_id: 1,
          start: this.pagination.start,
          limit: this.pagination.limits[this.pagination.current]
        };

        if (this.status) {
          data.status = this.status;
        }

        this.loading = true;
        this.axios.get(`/cameras`, { params: data })
          .then((response) => {
            this.loading = false;
            this.end = !response.data.cameras.length;
            this.total = response.data.total_count;
            this.pages = Math.ceil(this.total / this.pagination.limits[this.pagination.current]);

            if (!this.end) {
              this.cameras = response.data.cameras;
              this.getItems();
            }
          });
      },
    },
  };
</script>

<style scoped>
  #items-container {
    overflow-y: scroll !important;
  }

  .vd-footage-conatiner-box {
    display: flex;
    position: relative;
  }

  .footage-labels {
    position: absolute;
  }

  .row-footage-2 {
    width: 100%;
  }

  .video-dashboard-container {
    margin-right: 0;
  }

  .right-container-video {
    width: 100%;
  }

  .dashboard-grid-container {
    padding: 0 0 0 15px;
  }
</style>
